module.exports = __webpack_public_path__ + "img/video.4f4ab1e7.png";